/**
 * Where this app talks, where it remembers, and what its four screens are
 * called.
 *
 * `VITE_API_URL` is empty in dev, so the base url is the same-origin `/api/v1`
 * that Vite proxies to the API container. Set it to an absolute origin (which
 * must be listed in `CORS_ORIGINS`) to point a built bundle at a deployment.
 */
const origin = (import.meta.env.VITE_API_URL ?? '').replace(/\/+$/, '');

export const API_BASE_URL = `${origin}/api/v1`;

/**
 * This app's IndexedDB. Each app has its own device identity (D-06: one
 * active device per employee, and a supervisor's laptop is not a worker's
 * phone), so the two names must never be shared.
 */
export const IDB_NAME = 'saniplus-worker';

/**
 * The paths, in French, because the people reading the address bar are the
 * people the product is written for. `HOME_PATH` is the punch screen: a worker
 * who opens the app is opening it to punch.
 */
export const HOME_PATH = '/';
export const SHIFTS_PATH = '/quarts';
export const HOURS_PATH = '/heures';
export const PROFILE_PATH = '/profil';
/**
 * Phase 5 / P3: not one of the four bottom-nav tabs (`AppLayout.tsx`'s own
 * doc comment fixes that at four) — reached from the home screen's task line
 * and the punch screen's gated OUT key.
 */
export const TASKS_PATH = '/taches';
export const LOGIN_PATH = '/login';
export const PIN_CHANGE_PATH = '/pin';
/**
 * Phase 6 / P-01: the first-login photo offer. Authenticated and inside
 * `RequirePinChanged` — a worker who still owes a PIN change meets that first
 * — but outside the shell, because it is a full-screen offer with two ways
 * out (take one, or « Plus tard ») and no tab bar to wander off through.
 */
export const PHOTO_PROMPT_PATH = '/photo';

/**
 * Shown as a fact on the profile screen, so a supervisor on the phone can ask
 * "what does it say at the bottom of Profil?" and get an answer that means
 * something. Injected at build time; `0.0.0-dev` in a dev server.
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? '0.0.0-dev';
